// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Qm-z","tupacHeader":"Rm-z","tupacHeader2":"Sm-z","tupacMenu":"Tm-z","tupacMenu2":"Um-z","tupacMain":"Vm-z","tupacMain2":"Wm-z"};